// extracted by mini-css-extract-plugin
module.exports = {"logotype":"Header-module--logotype--3JyMs","link":"Header-module--link--3qc95","wrapper":"Header-module--wrapper--3rZRj"};